import script from "./photoCapture.vue?vue&type=script&lang=ts&setup=true"
export * from "./photoCapture.vue?vue&type=script&lang=ts&setup=true"

import "./photoCapture.vue?vue&type=style&index=0&id=71db9d1d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71db9d1d"]])

export default __exports__